/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RootMcpServerOption,
  RootMcpServerOption$inboundSchema,
} from "./rootmcpserveroption.js";

export type ListRootMcpServersResponseBody = {
  mcpServers: Array<RootMcpServerOption>;
};

/** @internal */
export const ListRootMcpServersResponseBody$inboundSchema: z.ZodMiniType<
  ListRootMcpServersResponseBody,
  unknown
> = z.pipe(
  z.object({
    mcp_servers: z.array(RootMcpServerOption$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_servers": "mcpServers",
    });
  }),
);

export function listRootMcpServersResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListRootMcpServersResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRootMcpServersResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRootMcpServersResponseBody' from JSON`,
  );
}
